import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;
let cancelRead;
// Commercial/Curtainwall
class CommercialScheduleApi extends Api {
  constructor() {
    super('commercial-schedules', 'commercial-schedules');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }

  async readWindowBreakdown(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    }, 'read-window-breakdown');
    return res;
  }
}

const commercialScheduleApi = new CommercialScheduleApi();

export default commercialScheduleApi;